import routes from '@/config/routes';
import { useEffect, useState, VFC } from 'react';
import { UserCollector } from '@/apis/aniftyBackend/users/interface';
import styles from './CollectorList.module.scss';
import { useTranslation } from 'next-i18next';
import fetchUserByID from '@/apis/aniftyBackend/users/fetchUserByID';
import getDisplayName from '@/utils/getDisplayName';
import { convertImgixURL } from '@/utils/imgixUtils';

type Props = {
  collector: UserCollector;
};

const CollectorBubble: VFC<Props> = ({ collector }: Props) => {
  const { i18n } = useTranslation();
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const { ProfilePicUrl, UserName, UserID, TwitterID } = collector;
  const [displayName, setDisplayName] = useState('');

  const userLink = UserName
    ? routes.creatorDetail(UserName)
    : routes.myPage(UserID);

  // Handle hover
  const handleMouseEnter = () => {
    setShowUserDropdown(true);
  };

  const handleMouseLeave = () => {
    setShowUserDropdown(false);
  };

  const backgroundImg = convertImgixURL(
    ProfilePicUrl || '/images/user-profile-page/default-profile-picture.png',
    { auto: 'compress' }
  );

  const getUserDisplayName = async () => {
    const user = await fetchUserByID(collector.UserID);
    const displayName = await getDisplayName(user, i18n.language);
    setDisplayName(displayName);
  };

  useEffect(() => {
    getUserDisplayName();
  }, []);

  return (
    <div
      className={styles.bubbleContainer}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <a href={userLink}>
        <div
          className={styles.circle}
          style={{
            backgroundImage: `url(${backgroundImg})`,
          }}
        />

        {showUserDropdown && (
          <div className={styles.dropdown}>
            <div className={styles.dropdownProfile}>
              <div
                style={{
                  backgroundImage: `url(${backgroundImg})`,
                }}
              ></div>
              {/* <div> Insert Follow Button here when functionality is available. doesn't do anything right now</div> */}
              {/* <div className={styles.followBtnContainer}>
                <CustomButton>Follow</CustomButton>
              </div> */}
            </div>
            <div className={styles.nameArea}>
              <h2>{displayName}</h2>
              {TwitterID && (
                <a href={`https://twitter.com/${TwitterID}`}>@{TwitterID}</a>
              )}
              {/* TODO. doesn't do anything right now */}
              {/* <div className={styles.followTxtContainer}>
                <div className={styles.followTxt}>
                  <h3>999</h3>
                  <span>Following</span>
                </div>
                <div className={styles.followTxt}>
                  <h3>999</h3>
                  <span>Followers</span>
                </div>
              </div> */}
            </div>
          </div>
        )}
      </a>
    </div>
  );
};

export default CollectorBubble;
